import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

// Common components
import TextClear from "common/components/text_clear";

// WxRecall SearchResult Components
import ToggleButton from "wxrecall/components/SearchResults/ToggleButton";

function ColumnFilter({ id, value, onToggle, onChange, filterType, intl }) {
  return (
    <div id={id} className="input-append">
      <TextClear
        attrs={{
          placeholder: intl.formatMessage({ id: "Filter Column" })
        }}
        value={value}
        onChange={e => onChange(e)}
      />
      <ToggleButton
        onToggle={onToggle}
        action="include"
        selected={filterType === undefined || filterType === "include"}
      />
      <ToggleButton
        onToggle={onToggle}
        action="exclude"
        selected={filterType === "exclude"}
        hide={!Boolean(onToggle)}
      />
    </div>
  );
}

ColumnFilter.propsTypes = {
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(ColumnFilter);
